/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedKennisbankRouteRouteImport } from './routes/_authenticated/kennisbank/route'
import { Route as AuthenticatedVehiclesIndexRouteImport } from './routes/_authenticated/vehicles/index'
import { Route as AuthenticatedKennisbankIndexRouteImport } from './routes/_authenticated/kennisbank/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedBookingsIndexRouteImport } from './routes/_authenticated/bookings/index'
import { Route as AuthenticatedVehiclesVehicleIdRouteImport } from './routes/_authenticated/vehicles/$vehicleId'
import { Route as AuthenticatedKennisbankSlugRouteImport } from './routes/_authenticated/kennisbank/$slug'
import { Route as AuthenticatedCallsHistoryRouteImport } from './routes/_authenticated/calls/history'
import { Route as AuthenticatedBookingsBookingIdRouteImport } from './routes/_authenticated/bookings/$bookingId'
import { Route as AuthenticatedAdminUsersIndexRouteImport } from './routes/_authenticated/admin/users/index'
import { Route as AuthenticatedAdminNotificationBannersIndexRouteImport } from './routes/_authenticated/admin/notification-banners/index'
import { Route as AuthenticatedAdminHelpdeskTopicsIndexRouteImport } from './routes/_authenticated/admin/helpdesk-topics/index'
import { Route as AuthenticatedAdminAuditIndexRouteImport } from './routes/_authenticated/admin/audit/index'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKennisbankRouteRoute =
  AuthenticatedKennisbankRouteRouteImport.update({
    id: '/kennisbank',
    path: '/kennisbank',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVehiclesIndexRoute =
  AuthenticatedVehiclesIndexRouteImport.update({
    id: '/vehicles/',
    path: '/vehicles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKennisbankIndexRoute =
  AuthenticatedKennisbankIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedKennisbankRouteRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBookingsIndexRoute =
  AuthenticatedBookingsIndexRouteImport.update({
    id: '/bookings/',
    path: '/bookings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVehiclesVehicleIdRoute =
  AuthenticatedVehiclesVehicleIdRouteImport.update({
    id: '/vehicles/$vehicleId',
    path: '/vehicles/$vehicleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKennisbankSlugRoute =
  AuthenticatedKennisbankSlugRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => AuthenticatedKennisbankRouteRoute,
  } as any)
const AuthenticatedCallsHistoryRoute =
  AuthenticatedCallsHistoryRouteImport.update({
    id: '/calls/history',
    path: '/calls/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBookingsBookingIdRoute =
  AuthenticatedBookingsBookingIdRouteImport.update({
    id: '/bookings/$bookingId',
    path: '/bookings/$bookingId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminUsersIndexRoute =
  AuthenticatedAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminNotificationBannersIndexRoute =
  AuthenticatedAdminNotificationBannersIndexRouteImport.update({
    id: '/notification-banners/',
    path: '/notification-banners/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminHelpdeskTopicsIndexRoute =
  AuthenticatedAdminHelpdeskTopicsIndexRouteImport.update({
    id: '/helpdesk-topics/',
    path: '/helpdesk-topics/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAuditIndexRoute =
  AuthenticatedAdminAuditIndexRouteImport.update({
    id: '/audit/',
    path: '/audit/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/kennisbank': typeof AuthenticatedKennisbankRouteRouteWithChildren
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/bookings/$bookingId': typeof AuthenticatedBookingsBookingIdRoute
  '/calls/history': typeof AuthenticatedCallsHistoryRoute
  '/kennisbank/$slug': typeof AuthenticatedKennisbankSlugRoute
  '/vehicles/$vehicleId': typeof AuthenticatedVehiclesVehicleIdRoute
  '/bookings/': typeof AuthenticatedBookingsIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/kennisbank/': typeof AuthenticatedKennisbankIndexRoute
  '/vehicles/': typeof AuthenticatedVehiclesIndexRoute
  '/admin/audit/': typeof AuthenticatedAdminAuditIndexRoute
  '/admin/helpdesk-topics/': typeof AuthenticatedAdminHelpdeskTopicsIndexRoute
  '/admin/notification-banners/': typeof AuthenticatedAdminNotificationBannersIndexRoute
  '/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/bookings/$bookingId': typeof AuthenticatedBookingsBookingIdRoute
  '/calls/history': typeof AuthenticatedCallsHistoryRoute
  '/kennisbank/$slug': typeof AuthenticatedKennisbankSlugRoute
  '/vehicles/$vehicleId': typeof AuthenticatedVehiclesVehicleIdRoute
  '/bookings': typeof AuthenticatedBookingsIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/kennisbank': typeof AuthenticatedKennisbankIndexRoute
  '/vehicles': typeof AuthenticatedVehiclesIndexRoute
  '/admin/audit': typeof AuthenticatedAdminAuditIndexRoute
  '/admin/helpdesk-topics': typeof AuthenticatedAdminHelpdeskTopicsIndexRoute
  '/admin/notification-banners': typeof AuthenticatedAdminNotificationBannersIndexRoute
  '/admin/users': typeof AuthenticatedAdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_authenticated/kennisbank': typeof AuthenticatedKennisbankRouteRouteWithChildren
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/bookings/$bookingId': typeof AuthenticatedBookingsBookingIdRoute
  '/_authenticated/calls/history': typeof AuthenticatedCallsHistoryRoute
  '/_authenticated/kennisbank/$slug': typeof AuthenticatedKennisbankSlugRoute
  '/_authenticated/vehicles/$vehicleId': typeof AuthenticatedVehiclesVehicleIdRoute
  '/_authenticated/bookings/': typeof AuthenticatedBookingsIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/kennisbank/': typeof AuthenticatedKennisbankIndexRoute
  '/_authenticated/vehicles/': typeof AuthenticatedVehiclesIndexRoute
  '/_authenticated/admin/audit/': typeof AuthenticatedAdminAuditIndexRoute
  '/_authenticated/admin/helpdesk-topics/': typeof AuthenticatedAdminHelpdeskTopicsIndexRoute
  '/_authenticated/admin/notification-banners/': typeof AuthenticatedAdminNotificationBannersIndexRoute
  '/_authenticated/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/unauthorized'
    | '/kennisbank'
    | '/admin'
    | '/bookings/$bookingId'
    | '/calls/history'
    | '/kennisbank/$slug'
    | '/vehicles/$vehicleId'
    | '/bookings/'
    | '/dashboard/'
    | '/kennisbank/'
    | '/vehicles/'
    | '/admin/audit/'
    | '/admin/helpdesk-topics/'
    | '/admin/notification-banners/'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/unauthorized'
    | '/admin'
    | '/bookings/$bookingId'
    | '/calls/history'
    | '/kennisbank/$slug'
    | '/vehicles/$vehicleId'
    | '/bookings'
    | '/dashboard'
    | '/kennisbank'
    | '/vehicles'
    | '/admin/audit'
    | '/admin/helpdesk-topics'
    | '/admin/notification-banners'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/unauthorized'
    | '/_authenticated/kennisbank'
    | '/_authenticated/admin'
    | '/_authenticated/bookings/$bookingId'
    | '/_authenticated/calls/history'
    | '/_authenticated/kennisbank/$slug'
    | '/_authenticated/vehicles/$vehicleId'
    | '/_authenticated/bookings/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/kennisbank/'
    | '/_authenticated/vehicles/'
    | '/_authenticated/admin/audit/'
    | '/_authenticated/admin/helpdesk-topics/'
    | '/_authenticated/admin/notification-banners/'
    | '/_authenticated/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kennisbank': {
      id: '/_authenticated/kennisbank'
      path: '/kennisbank'
      fullPath: '/kennisbank'
      preLoaderRoute: typeof AuthenticatedKennisbankRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vehicles/': {
      id: '/_authenticated/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles/'
      preLoaderRoute: typeof AuthenticatedVehiclesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kennisbank/': {
      id: '/_authenticated/kennisbank/'
      path: '/'
      fullPath: '/kennisbank/'
      preLoaderRoute: typeof AuthenticatedKennisbankIndexRouteImport
      parentRoute: typeof AuthenticatedKennisbankRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bookings/': {
      id: '/_authenticated/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof AuthenticatedBookingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vehicles/$vehicleId': {
      id: '/_authenticated/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/vehicles/$vehicleId'
      preLoaderRoute: typeof AuthenticatedVehiclesVehicleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kennisbank/$slug': {
      id: '/_authenticated/kennisbank/$slug'
      path: '/$slug'
      fullPath: '/kennisbank/$slug'
      preLoaderRoute: typeof AuthenticatedKennisbankSlugRouteImport
      parentRoute: typeof AuthenticatedKennisbankRouteRoute
    }
    '/_authenticated/calls/history': {
      id: '/_authenticated/calls/history'
      path: '/calls/history'
      fullPath: '/calls/history'
      preLoaderRoute: typeof AuthenticatedCallsHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bookings/$bookingId': {
      id: '/_authenticated/bookings/$bookingId'
      path: '/bookings/$bookingId'
      fullPath: '/bookings/$bookingId'
      preLoaderRoute: typeof AuthenticatedBookingsBookingIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/users/': {
      id: '/_authenticated/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthenticatedAdminUsersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/notification-banners/': {
      id: '/_authenticated/admin/notification-banners/'
      path: '/notification-banners'
      fullPath: '/admin/notification-banners/'
      preLoaderRoute: typeof AuthenticatedAdminNotificationBannersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/helpdesk-topics/': {
      id: '/_authenticated/admin/helpdesk-topics/'
      path: '/helpdesk-topics'
      fullPath: '/admin/helpdesk-topics/'
      preLoaderRoute: typeof AuthenticatedAdminHelpdeskTopicsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/audit/': {
      id: '/_authenticated/admin/audit/'
      path: '/audit'
      fullPath: '/admin/audit/'
      preLoaderRoute: typeof AuthenticatedAdminAuditIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedKennisbankRouteRouteChildren {
  AuthenticatedKennisbankSlugRoute: typeof AuthenticatedKennisbankSlugRoute
  AuthenticatedKennisbankIndexRoute: typeof AuthenticatedKennisbankIndexRoute
}

const AuthenticatedKennisbankRouteRouteChildren: AuthenticatedKennisbankRouteRouteChildren =
  {
    AuthenticatedKennisbankSlugRoute: AuthenticatedKennisbankSlugRoute,
    AuthenticatedKennisbankIndexRoute: AuthenticatedKennisbankIndexRoute,
  }

const AuthenticatedKennisbankRouteRouteWithChildren =
  AuthenticatedKennisbankRouteRoute._addFileChildren(
    AuthenticatedKennisbankRouteRouteChildren,
  )

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAuditIndexRoute: typeof AuthenticatedAdminAuditIndexRoute
  AuthenticatedAdminHelpdeskTopicsIndexRoute: typeof AuthenticatedAdminHelpdeskTopicsIndexRoute
  AuthenticatedAdminNotificationBannersIndexRoute: typeof AuthenticatedAdminNotificationBannersIndexRoute
  AuthenticatedAdminUsersIndexRoute: typeof AuthenticatedAdminUsersIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAuditIndexRoute: AuthenticatedAdminAuditIndexRoute,
  AuthenticatedAdminHelpdeskTopicsIndexRoute:
    AuthenticatedAdminHelpdeskTopicsIndexRoute,
  AuthenticatedAdminNotificationBannersIndexRoute:
    AuthenticatedAdminNotificationBannersIndexRoute,
  AuthenticatedAdminUsersIndexRoute: AuthenticatedAdminUsersIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedKennisbankRouteRoute: typeof AuthenticatedKennisbankRouteRouteWithChildren
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedBookingsBookingIdRoute: typeof AuthenticatedBookingsBookingIdRoute
  AuthenticatedCallsHistoryRoute: typeof AuthenticatedCallsHistoryRoute
  AuthenticatedVehiclesVehicleIdRoute: typeof AuthenticatedVehiclesVehicleIdRoute
  AuthenticatedBookingsIndexRoute: typeof AuthenticatedBookingsIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedVehiclesIndexRoute: typeof AuthenticatedVehiclesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedKennisbankRouteRoute:
    AuthenticatedKennisbankRouteRouteWithChildren,
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedBookingsBookingIdRoute: AuthenticatedBookingsBookingIdRoute,
  AuthenticatedCallsHistoryRoute: AuthenticatedCallsHistoryRoute,
  AuthenticatedVehiclesVehicleIdRoute: AuthenticatedVehiclesVehicleIdRoute,
  AuthenticatedBookingsIndexRoute: AuthenticatedBookingsIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedVehiclesIndexRoute: AuthenticatedVehiclesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
